import React from 'react';

type FontSizeOption = 'small' | 'medium' | 'large';

const fontSizeClasses: Record<FontSizeOption, string> = {
	small: 'text-xs',
	medium: 'text-sm',
	large: 'text-base'
};

interface LegendTableProps {
	data: {label: string, color: string}[]
	className?: string
	fontSize?: FontSizeOption
}

export const LegendTable: React.FC<LegendTableProps> = ({data, className, fontSize = 'small'}) => {
	
	return (
		<div className="flex items-center gap-6">
			{data.map((item, index) => (
				<div className={`flex items-center gap-2 ${className}`} key={index}>
					<div className="w-3 h-3 rounded-full" style={{backgroundColor: item.color}}></div>
					<span className={`${fontSizeClasses[fontSize]} text-gray-600 font-semibold`}>{item.label}</span>
				</div>
			))}
		</div>
	);
};
